import React from "react";
//import logo from "../../../images/logo.png";

const ConnectAccount = ({
  isOpen,
  handleAddAccount,
  handleUpdateAccount,
  handleCancelAccount,
  children,
  status,
}) => {
  if (!isOpen) return null;

  // console.log(status , "statusstatusstatusstatusstatusstatusstatus");

  return (
    <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
      <div className="flex items-center justify-center  px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="flex items-center justify-center fixed z-50 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center w-full pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg mx-auto sm:my-8 p-6">
              {/* Logo */}
              <div className="flex justify-center items-center mb-4">
                <img
                  src={"/qushi_logo.png"}
                  alt="Logo"
                  className="h-16 w-auto"
                />
              </div>

              {/* Modal Content */}
              <h2 className="text-lg font-bold text-primaryColor mb-4">
                {status === "completed"
                  ? "Account Details"
                  : "Add Country Origin"}
              </h2>
              {children}
              <div>
                {status === "completed" ? (
                  <button
                    className="bg-primaryColor hover:bg-primaryColor mt-2 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    onClick={handleUpdateAccount}
                  >
                    Update
                  </button>
                ) : (
                  <button
                    className="bg-primaryColor hover:bg-primaryColor mt-2 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    onClick={handleAddAccount}
                  >
                    Continue
                  </button>
                )}
                <button
                  className="bg-red-700 hover:bg-red-700 ml-2 text-white font-bold py-2 mt-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  onClick={handleCancelAccount}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectAccount;
